// -- Constants
if (!customElements.get('momax-everyday')) {
  customElements.define('momax-everyday', class extends HTMLElement {
    // -- Functions
    select(index) {
      this.index = Math.max(0, Math.min(index, this.items.length - 1));
      this.items.forEach((item, i) => {
        item.classList.toggle('is-active', i === this.index);
        const trigger = item.querySelector('[data-ever-select]');
        if (this.mobile.matches) trigger.removeAttribute('aria-expanded');
        else trigger.setAttribute('aria-expanded', String(i === this.index));
      });
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index >= this.items.length - 1;
      this.updateProgress();
    }

    updateProgress() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const count = this.items.length;
      const scrollFraction = max > 0 ? Math.max(0, Math.min(1, this.track.scrollLeft / max)) : 0;
      const current = this.mobile.matches ? Math.round(scrollFraction * (count - 1)) : this.index;
      this.progress.style.setProperty('--ever-progress', `${count ? (current + 1) / count * 100 : 0}%`);
    }

    // -- Lifecycle Hooks
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.items = Array.from(this.querySelectorAll('[data-ever-item]'));
      this.track = this.querySelector('[data-ever-track]');
      this.progress = this.querySelector('[data-ever-progress]');
      this.previous = this.querySelector('[data-ever-direction="-1"]');
      this.next = this.querySelector('[data-ever-direction="1"]');
      this.mobile = window.matchMedia('(max-width: 740px)');
      this.querySelector('[data-ever-controls]').hidden = this.items.length < 2;

      this.items.forEach((item, index) => {
        item.addEventListener('pointerenter', event => {
          if (!this.mobile.matches && event.pointerType === 'mouse') this.select(index);
        }, { signal });
        item.addEventListener('focusin', () => { if (!this.mobile.matches) this.select(index); }, { signal });
        item.querySelector('[data-ever-select]').addEventListener('click', () => {
          if (!this.mobile.matches) this.select(index);
          else this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'auto' });
        }, { signal });
      });

      [this.previous, this.next].forEach(button => button.addEventListener('click', () => this.select(this.index + Number(button.dataset.everDirection)), { signal }));

      this.track.addEventListener('keydown', event => {
        if (this.mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.select(next);
        this.items[this.index]?.querySelector('[data-ever-select]').focus({ preventScroll: true });
      }, { signal });

      this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true, signal });
      this.mobile.addEventListener('change', () => this.select(this.index), { signal });
      this.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.select(index);
        if (this.mobile.matches) this.track.scrollTo({ left: this.items[index].offsetLeft - this.items[0].offsetLeft, behavior: 'auto' });
      }, { signal });

      this.resizeObserver = new ResizeObserver(() => this.updateProgress());
      this.resizeObserver.observe(this.track);
      this.select(0);
    }
    disconnectedCallback() {
      this.controller.abort();
      this.resizeObserver.disconnect();
    }
  });
}
